import { render, staticRenderFns } from "./wechat1.vue?vue&type=template&id=f52adc82&scoped=true&"
import script from "./wechat1.vue?vue&type=script&lang=js&"
export * from "./wechat1.vue?vue&type=script&lang=js&"
import style0 from "./wechat1.vue?vue&type=style&index=0&id=f52adc82&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f52adc82",
  null
  
)

export default component.exports